import React from 'react';
import { useNavigate } from 'react-router-dom';

const NotFoundPage: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 relative overflow-hidden">
            {/* Background decorative elements */}
            <div className="absolute inset-0 pointer-events-none">
                <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-teal-500/5 rounded-full blur-3xl"></div>
                <div className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-blue-500/5 rounded-full blur-3xl"></div>
            </div>

            <div className="text-center px-6 relative z-10 max-w-lg">
                {/* Large 404 */}
                <div className="mb-6">
                    <h1 className="text-[120px] sm:text-[160px] font-black leading-none bg-gradient-to-br from-teal-400 via-cyan-400 to-blue-500 bg-clip-text text-transparent select-none">
                        404
                    </h1>
                </div>

                {/* Icon */}
                <div className="mb-6 flex justify-center">
                    <div className="w-20 h-20 rounded-full bg-slate-800/80 border border-slate-700 flex items-center justify-center shadow-xl">
                        <span className="material-icons-round text-4xl text-teal-400">explore_off</span>
                    </div>
                </div>

                {/* Title */}
                <h2 className="text-2xl sm:text-3xl font-bold text-white mb-3">
                    Sidan hittades inte
                </h2>

                {/* Description */}
                <p className="text-gray-400 text-base sm:text-lg mb-8 leading-relaxed">
                    Sidan du letar efter finns inte eller har flyttats. Kontrollera webbadressen eller gå tillbaka till startsidan.
                </p>

                {/* Go to Homepage Button */}
                <button
                    onClick={() => navigate('/')}
                    className="inline-flex items-center gap-2.5 px-8 py-3.5 bg-gradient-to-r from-teal-500 to-cyan-500 text-white font-semibold rounded-xl hover:from-teal-600 hover:to-cyan-600 transition-all duration-300 shadow-lg shadow-teal-500/25 hover:shadow-teal-500/40 hover:scale-[1.02] active:scale-[0.98]"
                >
                    <span className="material-icons-round text-xl">home</span>
                    Gå till startsidan
                </button>

                {/* Subtle footer text */}
                <p className="mt-10 text-xs text-gray-600">
                    Lumi Tours &bull; lumitours.se
                </p>
            </div>
        </div>
    );
};

export default NotFoundPage;
